(function () {
      function initFaqTabs(root) {
        if (!root || root.dataset.tabsInit === "1") return;
        root.dataset.tabsInit = "1";

        const tabs = Array.from(root.querySelectorAll(".tabs .tab"));
        const groups = Array.from(root.querySelectorAll(".group"));

        tabs.forEach((tab) => {
          tab.setAttribute("role", "button");
          tab.setAttribute("tabindex", "0");
        });

        function setActive(cat) {
          tabs.forEach((tab) => {
            const target = (tab.getAttribute("for") || "").replace("faq-", "");
            tab.classList.toggle("is-active", target === cat);
          });

          groups.forEach((group) => {
            const groupCat = group.getAttribute("data-cat") || "";
            group.classList.toggle("is-active-group", groupCat === cat);
          });
        }

        function activateTab(tab) {
          const cat = (tab.getAttribute("for") || "").replace("faq-", "");
          if (!cat) return;

          const input = root.querySelector("#faq-" + cat);
          if (input) {
            input.checked = true;
          }

          setActive(cat);
        }

        tabs.forEach((tab) => {
          tab.addEventListener("click", (event) => {
            event.preventDefault();
            activateTab(tab);
          });

          tab.addEventListener("keydown", (event) => {
            if (event.key !== "Enter" && event.key !== " ") return;
            event.preventDefault();
            activateTab(tab);
          });
        });

        setActive("top");
      }

      document.querySelectorAll(".sp-faq").forEach(initFaqTabs);
    })();